import { Link } from "react-router-dom";
import { HeartHandshake, Store, Megaphone, Mail, ArrowRight } from "lucide-react";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import { STATS } from "@/data/site";

const OPTIONS = [
  {
    icon: HeartHandshake,
    title: "Sponsoring",
    desc: "Twoje logo na stronie, w materiałach wydarzenia i na scenie. Marka obecna tam, gdzie rodzą się emocje i relacje.",
  },
  {
    icon: Store,
    title: "Stoisko partnerskie",
    desc: "Bezpośredni kontakt z uczestniczkami — pokaz produktów, rozmowy, próbki. Setki mam w jednym miejscu, przez cały dzień.",
  },
  {
    icon: Megaphone,
    title: "Patronat medialny",
    desc: "Dla mediów, podcastów i blogów, które chcą opowiadać o wydarzeniu dalej i wzmacniać głos mam w przestrzeni publicznej.",
  },
];

export default function Wspolpraca() {
  useDocumentTitle("Współpraca", "Współpraca z mamy!kongres — sponsoring, stoiska partnerskie, patronaty medialne. Dotrzyj do setek świadomych mam.");
  return (
    <div data-testid="cooperation-page">
      <section className="max-w-5xl mx-auto px-6 lg:px-10 pt-8 pb-14 relative">
        <div className="absolute -top-10 -right-10 w-72 h-72 rounded-full bg-[#E6007A]/15 blur-3xl pointer-events-none" />
        <div className="absolute top-20 -left-20 w-64 h-64 rounded-full bg-[#F48DBF]/25 blur-3xl pointer-events-none" />
        <div className="text-xs uppercase tracking-[0.3em] text-[#E6007A] mb-6 relative">
          Zostań sponsorem
        </div>
        <h1 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[1.02] mb-8 relative">
          Zbudujmy to <br />
          <span className="italic text-[#E6007A]">razem</span>.
        </h1>
        <p className="text-xl text-[#5C534D] leading-relaxed max-w-3xl relative">
          mamy!kongres to spotkanie kobiet, które podejmują świadome decyzje — o sobie,
          o rodzinie, o zakupach. Jeśli Twoja marka podziela te wartości, to idealne miejsce,
          żeby się pokazać.
        </p>
      </section>

      <section className="max-w-6xl mx-auto px-6 lg:px-10 pb-16">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {STATS.map((s) => (
            <div
              key={s.label}
              className="rounded-[28px] bg-[#F4EFE6] p-6 text-center"
            >
              <div className="font-display text-4xl md:text-5xl text-[#E6007A] mb-1">{s.value}</div>
              <div className="text-sm text-[#5C534D]">{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-6 lg:px-10 pb-24">
        <div className="grid md:grid-cols-3 gap-8 items-stretch">
          {OPTIONS.map((o, i) => {
            const Icon = o.icon;
            return (
              <article
                key={o.title}
                data-testid={`cooperation-option-${o.title.toLowerCase().replace(/\s+/g, "-")}`}
                className="relative rounded-[32px] bg-[#FDDAE3] border border-[#F4B7CA] p-8 md:p-10 shadow-[0_10px_30px_rgba(230,0,122,0.06)] transition-transform duration-300 hover:-translate-y-1"
              >
                <div className={`w-12 h-12 rounded-full text-white grid place-items-center mb-6 ${i % 2 === 0 ? "bg-[#2E4331]" : "bg-[#E6007A]"}`}>
                  <Icon className="w-5 h-5" />
                </div>
                <h2 className="font-display text-2xl md:text-3xl leading-tight mb-3">
                  {o.title}
                </h2>
                <p className="text-[#3d3733] leading-relaxed">{o.desc}</p>
              </article>
            );
          })}
        </div>
      </section>

      <section className="bg-[#F4EFE6] py-16">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 text-center">
          <h2 className="font-display text-3xl md:text-4xl mb-4">
            Porozmawiajmy o szczegółach
          </h2>
          <p className="text-[#5C534D] leading-relaxed mb-8 max-w-2xl mx-auto">
            Napisz do nas — przygotujemy ofertę dopasowaną do Twojej marki i celów.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="mailto:hej@mamykongres.pl"
              data-testid="cooperation-cta-email"
              className="btn-lift inline-flex items-center gap-3 rounded-full bg-[#E6007A] px-10 py-5 text-white font-semibold text-lg"
            >
              <Mail className="w-5 h-5" />
              hej@mamykongres.pl
            </a>
            <Link
              to="/kontakt"
              data-testid="cooperation-cta-contact"
              className="inline-flex items-center gap-2 font-semibold text-[#E6007A] link-underline"
            >
              lub przez formularz kontaktowy
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
